import * as actions from "../actions/";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import GlobalListingDetail from "../components/listing-detail/globalListingDetails";

const mapStateToProps = (state) => {
  return {
    entity: state.store.entity,
    config: state.store.config,
    listing: state.store.listing,
    defaultOptions: state.store.defaultOptions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GlobalListingDetail);



// WEBPACK FOOTER //
// ./src/containers/global-listing-detail.js